<template>
  <div class="w-max h-max is-vertical-center fixed-tl has-text-centered" style="z-index: 9999;background: white;">
    <div class="is-fullwidth">
      <p style="font-size:8rem;">{{ current }}</p>
      <p @click="end" class="is-size-4 is-uppercase">{{ 'Skip' | translate }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Counter',
  props: ['from'],
  data () {
    var current = this.from || 0
    return {
      current,
      interval: undefined
    }
  },
  methods: {
    start(n) {
      if (typeof n === 'number') {
        this.current = n
      }

      this.interval = setInterval(this.go, 1000)
    },
    go() {
      this.current--
      if (this.current <= 0) {
        this.end()
      }
    },
    end() {
      clearInterval(this.interval)
      this.$emit('end')
    }
  }
}
</script>

<style>
</style>






// WEBPACK FOOTER //
// src/components/Settings/Counter.vue